/* src/app/contract-calculation/claim-calculation-list/claim-calculation-list.component.css */
:host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.old-claim-info {
  color: #d32f2f;
  font-size: 0.75rem;
  margin-top: 0.25rem;
}
/*# sourceMappingURL=claim-calculation-list.component-5OVEOUWZ.css.map */
